import React from "react";
import { Box, Typography, Card, CardContent,Grid, } from "@mui/material";
import Data from "../pages/Data/Activitie.json";
import ActivitieCard from "./Card/ActivitieCard";
import Container from '@mui/material/Container';

const Activities = ({ image, title, description }) => {

    const currentSubject = Data?.Activitie || []; // Ensure `currentSubject` is safely accessed

    return (
        
            <Box sx={{ p: 4, textAlign: "center", backgroundColor:"#e3f3ff" }}>
                <Container maxWidth="lg">
                <Typography
                    variant="h3"
                    sx={{ fontWeight: "bold", padding:"80px",color: "#1976d2" }}
                >
                    Activities
                </Typography>
                <Grid   spacing={4} justifyContent="center">
                    {currentSubject.map((subject, index) => (
                        <Grid item xs={6} md={6} lg={4} key={index}>
                            <ActivitieCard
                                image={subject.image}
                                title={subject.title}
                                description={subject.description}
                                index={index}
                            />
                        </Grid>
                    ))}
                </Grid>
                </Container>
            </Box>
            
         
    );
};

export default Activities;
